import { overlaySlice } from './overlay.slices';
import { playerSlice } from './player.slices';
import { userSlice } from './user.slices';
import { programGuideSlices } from './program-guide.slices';
import { typeIssueSortingSlices } from './type-issue-sorting.slices';
import { blindModeSlice } from './blind-mode.slices';

export const reducerSlices = {
  [overlaySlice.name]: overlaySlice.reducer,
  [playerSlice.name]: playerSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [programGuideSlices.name]: programGuideSlices.reducer,
  [typeIssueSortingSlices.name]: typeIssueSortingSlices.reducer,
  [blindModeSlice.name]: blindModeSlice.reducer,
};
